import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import useCurrencySymbol from 'hooks/redux/Brands/useCurrencySymbol';
import LabeledCheckbox from 'components/Checkbox/LabeledCheckbox';
import CardWrapper from 'components/Card/CardWrapper';
import CardBody from 'components/Card/CardBody';
import { SelectInput } from 'components';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';
import { grayColor } from 'assets/jss/material-dashboard-pro-react';

const useStyles = makeStyles({
  infoIcon: {
    color: grayColor[0],
  },
  selectedDietsCheckWrapper: {
    display: 'flex',
  },
  diets: {
    marginRight: '4px',
  },
});

const ScopeOfActivitySections = ({
  scopeOfActivitySection,
  setScopeOfActivitySection,
  diets,
  isEdit,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const currencySymbol = useCurrencySymbol();

  return (
    <CardWrapper title={t('discountCodes.scopeOfActivity')}>
      <CardBody>
        <GridContainer>
          <GridItem sm={12}>
            <LabeledCheckbox
              checked={scopeOfActivitySection.isSelectedDiets}
              onChange={e => {
                setScopeOfActivitySection(prev => ({
                  ...prev,
                  isSelectedDiets: e.target.checked,
                  dietsState: [],
                }));
              }}
              label={
                <div>
                  <span className={classes.diets}>
                    {t('discountCodes.diets2')}:
                  </span>
                  <InfoIconTooltip
                    title={
                      <>
                        <p>{t('discountCodes.tooltip4')}</p>
                        <p>{t('discountCodes.tooltip5')}</p>
                        <p>{t('discountCodes.tooltip6', { currencySymbol })}</p>
                        {t('discountCodes.tooltip7', { currencySymbol })}
                      </>
                    }
                  />
                </div>
              }
            />
          </GridItem>
          <GridItem sm={6}>
            <SelectInput
              multiple={true}
              mapBy="name"
              trackBy="@id"
              name="diets"
              value={scopeOfActivitySection.dietsState}
              options={diets}
              handleChange={e => {
                setScopeOfActivitySection(prev => ({
                  ...prev,
                  dietsState: e.target.value,
                  isSelectedDiets: true,
                }));
              }}
              id="diets"
              size={12}
            />
          </GridItem>
          <GridItem sm={12}>
            <LabeledCheckbox
              checked={scopeOfActivitySection.isApplyToAddons}
              onChange={e =>
                setScopeOfActivitySection(prev => ({
                  ...prev,
                  isApplyToAddons: e.target.checked,
                }))
              }
              label={t('discountCodes.applyToAddons')}
              disabled={isEdit}
            />
          </GridItem>
          <GridItem sm={12}>
            <LabeledCheckbox
              checked={scopeOfActivitySection.isDisableDietDiscount}
              onChange={e =>
                setScopeOfActivitySection(prev => ({
                  ...prev,
                  isDisableDietDiscount: e.target.checked,
                }))
              }
              label={t('discountCodes.disableDietDiscount')}
            />
          </GridItem>
          <GridItem sm={12}>
            <LabeledCheckbox
              checked={scopeOfActivitySection.isFreeDelivery}
              onChange={e =>
                setScopeOfActivitySection(prev => ({
                  ...prev,
                  isFreeDelivery: e.target.checked,
                  isExcludeDeliveryFromDiscount: e.target.checked
                    ? false
                    : prev.isExcludeDeliveryFromDiscount,
                }))
              }
              label={t('discountCodes.freeDelivery')}
              disabled={isEdit}
            />
          </GridItem>
          <GridItem sm={12}>
            <LabeledCheckbox
              checked={scopeOfActivitySection.isExcludeDeliveryFromDiscount}
              onChange={e =>
                setScopeOfActivitySection(prev => ({
                  ...prev,
                  isExcludeDeliveryFromDiscount: e.target.checked,
                }))
              }
              label={t('discountCodes.excludeDeliveryFromDiscount')}
              disabled={isEdit || scopeOfActivitySection.isFreeDelivery}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
    </CardWrapper>
  );
};

export default ScopeOfActivitySections;
